function googleTranslateElementInit() {
    new google.translate.TranslateElement({pageLanguage: 'ja', includedLanguages: 'en,ja,zh-TW', layout: google.translate.TranslateElement.InlineLayout.HORIZONTAL, autoDisplay: false}, 'google_translate_element');
}
app.component('googleTranslate', {
    templateUrl: 'app/common/component/googleTranslate/googleTranslate.html',
    controller: function ($timeout) {
        var $ctrl = this;
        $ctrl.langSelect = function() {
            var evt = document.createEvent("HTMLEvents");       
            evt.initEvent("change", true, true);
            var lang_select_element = document.getElementsByClassName('goog-te-combo')[0];
            $timeout(function() {
                angular.element(lang_select_element).val($ctrl.lang);
                lang_select_element.dispatchEvent(evt);
            }, 400);
        };
    },
    bindings: {
        lang : '<'
    }
});
app.directive('transelateElementLoaded', function ( transelateElementState ) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            new MutationObserver(function () {
                if( transelateElementState.getState() == "notLoad") {
                    transelateElementState.setState("Loaded");
                    scope.$eval(attrs['transelateElementLoaded']);
                }
            }).observe(element[0], {
                attributes: true,
                characterData: true,
                childList: true,
                subtree: true
            });
        }
    };
});
app.factory("transelateElementState", function( localStorageAccess ) {
    var _state = "notLoad";
    return {
        "getState" : function() {
            return _state;
        },
        "setState" : function(svalue) {
            _state = svalue;
        }
    }

});